/**
 * Trancy - AI Translator & Dual Subtitles — video translation / language learning
 *
 * Declares a single web-accessible-resource entry matched to http(s) origins with no
 * `use_dynamic_url`, exposing all of `assets/*`. Every bundled icon, script and
 * stylesheet is therefore fetchable from any http(s) page at a fixed URL.
 *
 * The hero logo is the cleanest signal: a vendor-named asset that loads through
 * `probeImage` with no CORS grant, so it survives a strict page CSP.
 *
 * Manifest verified against version 7.8.9.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'mjdbhokoopacimoekfgkcoogikbfgngb';

export const trancy: ExtensionDefinition = {
  id: ID,
  name: 'Trancy - AI Translator & Dual Subtitles',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  notes:
    'All of assets/* exposed to http(s) origins with no dynamic URL. The vendor-named ' +
    'hero logo loads without a CORS grant, so detection is conclusive.',
  signals: [
    {
      id: 'war-hero-logo-image',
      kind: 'web-accessible-resource',
      description:
        'Load assets/hero_logo.svg via <img> — a vendor-named logo exposed to every ' +
        'http(s) origin; needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'assets/hero_logo.svg'),
    },
    {
      id: 'war-icon-auto',
      kind: 'web-accessible-resource',
      description:
        'Load assets/icon_auto.png via <img> — a second packaged icon corroborating the ' +
        'identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'assets/icon_auto.png'),
    },
    {
      id: 'war-edreader-main-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/edreader-main.js — a vendor-named bundle, independent of the image ' +
        'paths.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/edreader-main.js'),
    },
  ],
};
